<soft-page>
  <router-outlet></router-outlet>
</soft-page>
